// extracted by mini-css-extract-plugin
module.exports = {"container":"_352cdf8"};